"use client";

import { EdgenModalCreateAble } from "@/src/components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@/src/components/EdgenModal/waitForEdgenModalRoot";
import { TrackersSetupOnboardingModalContent } from "./TrackersSetupOnboardingModalContent";
import type {
  OpenTrackersSetupOnboardingModalParams,
  TrackersSetupModalAction,
} from "./types";

type TrackersSetupModalResult = { action: TrackersSetupModalAction };

let pendingTrackersSetupModal: Promise<TrackersSetupModalResult> | null = null;

/**
 * Trackers setup onboarding — H5 fullscreen / PC centered modal.
 * Closes only via bottom CTA (mask not closable).
 */
export const openTrackersSetupOnboardingModal = (
  params: OpenTrackersSetupOnboardingModalParams = {},
): Promise<TrackersSetupModalResult> => {
  if (pendingTrackersSetupModal) {
    return pendingTrackersSetupModal;
  }

  pendingTrackersSetupModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<TrackersSetupModalResult>((resolve) => {
        let settled = false;
        const finish = (action: TrackersSetupModalAction) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingTrackersSetupModal = null;
          EdgenModalCreateAble.end(false);
          resolve({ action });
        };

        EdgenModalCreateAble.call({
          children: (
            <TrackersSetupOnboardingModalContent
              payload={params.payload}
              onClose={(action = "save") => {
                finish(action);
              }}
            />
          ),
          className:
            "[--modal-radius:0px] md:[--modal-radius:24px] [--modal-height:100dvh] md:[--modal-height:90vh] md:[--modal-width:600px] [--modal-width:100%]",
          contentStyle: {
            borderRadius: "var(--modal-radius)",
            width: "var(--modal-width)",
            height: "var(--modal-height)",
            overflow: "hidden",
            padding: 0,
          },
          styles: {
            body: {
              height: "100%",
            },
          },
          containerStyle: {
            height: "100%",
            width: "100%",
            maxHeight: "100%",
          },
          titleStyle: {
            minHeight: 0,
          },
          showClose: false,
          maskClosable: false,
          destroyOnClose: true,
        });
      }),
  ).catch((error) => {
    pendingTrackersSetupModal = null;
    throw error;
  });

  return pendingTrackersSetupModal;
};
